import { P1 } from "components"
import { useState } from "react"
import DptObjectivesTab from "../component/DptObjectivesTab"
import DashboardWrapper from "components/new-stuff/ui/DashboardWrapper"
import { useSearchParams } from "react-router-dom"
import MembersTab from "../component/department/MembersTab"
import { newArchAxiosInstance } from "utils/request"
import { useQuery } from "@tanstack/react-query"
import { CustomSpin } from "components/custom/Loader"
import ibjImg from "pages/employee-dashboard/performance-new/images/your-obj.png"
import CycleDurationSelectAdmin from "../../review/components/CycleDurationSelect"
import ActionsButton from "components/new-stuff/ui/ActionsButton"
import { TopActionBar } from "components/new-stuff/ui/TopActionBar"
import { useCycleDurationAdminStore } from "stores"
import { CreateEditKR } from "../../components/objectives/CreateEditKR"
import { CreateEditDptObj } from "../../components/objectives/CreateEditDptObj"
import getIdFromKey from "utils/getIdFromKey"

interface props {
  showBack?: boolean
  handleBack?: () => void
  showTeam?: boolean
  showMembers?: boolean
  title?: string
}

const ViewDepartment = ({ showTeam = false, showMembers = false }: props) => {
  const [modal, setModal] = useState({
    type: "" as "add-kr" | "add-obj" | "",
  })

  const [searchParams, setSearchParams] = useSearchParams()
  const activeTab = searchParams.get("department-tab") || "Objectives"
  const deptKey = searchParams.get("id")
  const id = getIdFromKey(deptKey || "")
  const selectedCDData = useCycleDurationAdminStore(
    (state) => state.selectedCDData
  )
  const selectedCycle = Number(selectedCDData?.id)

  const tabsData = [
    { title: "Objectives", route: "" },
    ...(showTeam ? [{ title: "Team", route: "" }] : []),
    ...(showMembers ? [{ title: "Members", route: "" }] : []),
    // { title: "Individual", route: "/dashboard/performance/okr?id=Individual" },
  ]

  const { data: dptKRData, isLoading: isLoadingDetails } = useQuery<any>({
    queryFn: async () => {
      const res = await newArchAxiosInstance.get(
        `/api/v2/admin/okr/departmentobjectives/${id}?cycleDurationId=${selectedCycle}`
      )
      return res.data
    },
    queryKey: ["dpt-obj", id, selectedCDData.key],
    enabled: !!id && !!selectedCycle,
  })

  const renderTabComponent = () => {
    switch (activeTab.toLowerCase()) {
      case "objectives":
        return <DptObjectivesTab data={dptKRData} />
      // case "team":
      //   return <TeamTab />
      case "members":
        return (
          <MembersTab
            id={id ? parseInt(id) : null}
            selectedCycle={selectedCycle ? Number(selectedCycle) : null}
            MEMURL={`api/v2/admin/okr/employeeobjectivesummary/${
              id ? parseInt(id) : null
            }/${selectedCycle ? Number(selectedCycle) : null}`}
            navigateURL="/dashboard/performance/okr/individual"
          />
        )
      default:
        return null
    }
  }

  return (
    <>
      <TopActionBar>
        <div />
        <div className="flex justify-between items-center gap-4 ">
          <CycleDurationSelectAdmin />
          <ActionsButton
            items={[
              {
                key: "department",
                label: (
                  <button
                    onClick={() => setModal({ type: "add-obj" })}
                    className="font-circular !text-neutral400 w-full text-left"
                  >
                    Departmental Objective
                  </button>
                ),
              },
              {
                key: "employee",
                label: (
                  <button
                    onClick={() => setModal({ type: "add-kr" })}
                    className="font-circular !text-neutral400 w-full text-left"
                  >
                    Employee Key Result
                  </button>
                ),
              },
            ]}
            title="Create"
          />
        </div>
      </TopActionBar>
      <DashboardWrapper>
        {isLoadingDetails ? (
          <div className="flex justify-center items-center h-screen">
            <CustomSpin spinning />
          </div>
        ) : (
          <div className="font-circular">
            {/* {showBack && (
              <button
                onClick={() => {
                  navigate(-1)
                }}
                className="mb-3 flex items-center  font-medium"
              >
                <img
                  src="https://padehrs3-staging.s3.us-east-2.amazonaws.com/images/624451f9-8f2b-4be8-a94f-d17d652bf99e.svg"
                  className="h-5 w-5 text-padeBlack"
                />
                <H7 className="text-neutral100 ">Back</H7>
              </button>
            )} */}
            <div className="mb-10 bg-white  rounded-5px pt-8 px-6">
              <div className="flex flex-col justify-between">
                <div className="flex justify-between gap-4">
                  <div className=" flex  items-center gap-4 justify-start ">
                    <img
                      src="https://padehrs3-staging.s3.us-east-2.amazonaws.com/images/130ba1a6-84e2-42b0-ba86-7d572c996ed7.svg"
                      alt=""
                    />
                    <span className="text-padeBlack font-semibold text-xl font-circular">
                      {dptKRData?.data && dptKRData?.data[0]?.departmentName}{" "}
                      Department
                    </span>
                  </div>
                  <div className="hidden md:flex shrink">
                    <img
                      src={ibjImg}
                      className="w-[145px] self-end"
                    />
                  </div>
                </div>

                <div className="mt-4 flex items-center gap-6 border-b scrollbar-hide border-b-neutral40 bg-white overflow-x-auto">
                  {tabsData.map((tab, index) => (
                    <>
                      <div
                        className={` h-full relative flex items-center  cursor-pointer py-3`}
                        onClick={() => {
                          setSearchParams((prev) => {
                            const newParams = new URLSearchParams(prev)
                            newParams.set("department-tab", tab.title)
                            return newParams
                          })
                        }}
                      >
                        <P1
                          className={`whitespace-nowrap leading-none px-2 ${
                            (activeTab.toLowerCase() ===
                              tab.title.toLowerCase()) ===
                            true
                              ? "font-semibold text-primary500"
                              : "text-[#344054]"
                          }`}
                        >
                          {tab.title}
                        </P1>
                        {(activeTab.toLowerCase() ===
                          tab.title.toLowerCase()) ===
                          true && (
                          <div className="w-full max absolute bottom-0 h-[3px] bg-primary500" />
                        )}
                      </div>
                    </>
                  ))}
                </div>
              </div>
            </div>

            {<div className="">{renderTabComponent()}</div>}
          </div>
        )}
      </DashboardWrapper>

      {modal.type === "add-obj" && (
        <CreateEditDptObj
          open={modal.type === "add-obj"}
          onClose={() => setModal({ type: "" })}
          role="admin"
          deptId={Number(id)}
        />
      )}

      {modal.type === "add-kr" && (
        <CreateEditKR
          onClose={() => {
            setModal({ type: "" })
          }}
          open={modal.type === "add-kr"}
          role={"admin"}
          deptId={Number(id)}
          // deptId={employeeInfo?.data?.departmentId}
        />
      )}
    </>
  )
}

export default ViewDepartment
